module.exports = __webpack_public_path__ + "img/9791190422307.0299bb41.jpg";